export { insecureHash } from "./js-sha1/hash.js";
